import React from 'react';
import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import Icon from '../../components/AppIcon';

const BusinessBenefitsLanding = () => {
  const beneficiosClave = [
    {
      icon: "Store",
      title: "Perfil Comercial Completo",
      description: "Crea un perfil profesional con información detallada de tu negocio, horarios, ubicación, productos y servicios"
    },
    {
      icon: "QrCode",
      title: "Código QR Automático",
      description: "Recibe un código QR único para que tus clientes te encuentren fácilmente y accedan a tus descuentos exclusivos"
    },
    {
      icon: "BarChart3",
      title: "Panel de Analytics",
      description: "Analiza el comportamiento de tus clientes: visitas, escaneos de QR, interacciones y métricas de rendimiento en tiempo real"
    },
    {
      icon: "Image",
      title: "Publicaciones Estilo Redes Sociales",
      description: "Comparte contenido visual como Instagram: fotos de productos, promociones, eventos y novedades para atraer más clientes"
    },
    {
      icon: "Users",
      title: "Base de Datos de Clientes",
      description: "Identifica a tus visitantes por nombre, contacto y frecuencia de visitas. Conoce mejor a tu audiencia"
    },
    {
      icon: "Globe",
      title: "Visibilidad en Directorio",
      description: "Aparece en el directorio empresarial de BIZZNET visible para miles de usuarios que buscan descuentos"
    },
    {
      icon: "MessageSquare",
      title: "Comunicación Directa",
      description: "Establece contacto directo con tus clientes a través de la plataforma para consultas, reservas o información"
    },
    {
      icon: "TrendingUp",
      title: "Aumenta tus Ventas",
      description: "Atrae nuevos clientes con descuentos exclusivos y aumenta la frecuencia de visitas de clientes habituales"
    }
  ];

  const funcionesPremium = [
    {
      icon: "BadgePercent",
      title: "Descuentos Personalizados",
      description: "Configura descuentos por categoría, producto o servicio con vigencia y términos específicos"
    },
    {
      icon: "Calendar",
      title: "Promociones Programadas",
      description: "Planifica ofertas especiales por fechas: fines de semana, temporadas altas, eventos especiales"
    },
    {
      icon: "Bell",
      title: "Notificaciones Push",
      description: "Envía alertas a clientes cercanos sobre promociones activas o eventos importantes de tu negocio"
    },
    {
      icon: "Camera",
      title: "Galería de Fotos",
      description: "Sube imágenes de tu local, productos y servicios para mostrar la calidad de tu oferta"
    },
    {
      icon: "Star",
      title: "Sistema de Reseñas",
      description: "Recibe valoraciones y comentarios de clientes verificados para mejorar tu reputación online"
    },
    {
      icon: "Shield",
      title: "Verificación Oficial",
      description: "Obtén insignia de negocio verificado para generar mayor confianza en los usuarios"
    }
  ];

  const procesoPaso = [
    {
      numero: "1",
      titulo: "Registro Gratuito",
      descripcion: "Crea tu cuenta empresarial sin costo. Solo necesitas información básica de tu negocio",
      icon: "UserPlus"
    },
    {
      numero: "2",
      titulo: "Completa tu Perfil",
      descripcion: "Agrega fotos, horarios, ubicación, categorías y descripción detallada de tus productos/servicios",
      icon: "FileText"
    },
    {
      numero: "3",
      titulo: "Configura Descuentos",
      descripcion: "Define los porcentajes de descuento, categorías aplicables y términos de cada promoción",
      icon: "Settings"
    },
    {
      numero: "4",
      titulo: "Recibe tu Código QR",
      descripcion: "Sistema genera automáticamente tu código QR único vinculado a tu perfil y ofertas",
      icon: "QrCode"
    },
    {
      numero: "5",
      titulo: "Publica y Atrae",
      descripcion: "Comparte contenido, aparece en búsquedas del directorio y comienza a recibir visitas de clientes",
      icon: "Rocket"
    }
  ];

  const testimonios = [
    {
      negocio: "Restaurante El Sabor Colombiano",
      ciudad: "Pasto",
      comentario: "Desde que nos unimos a BIZZNET, nuestras ventas aumentaron 40%. El sistema de QR y descuentos atrae muchos clientes nuevos cada semana",
      calificacion: 5,
      persona: "María González - Propietaria"
    },
    {
      negocio: "Boutique Moda Urbana",
      ciudad: "Bogotá",
      comentario: "El panel de analytics es increíble. Ahora sé qué días tengo más visitas y puedo programar promociones en momentos estratégicos",
      calificacion: 5,
      persona: "Carlos Ramírez - Gerente"
    },
    {
      negocio: "Gimnasio FitLife",
      ciudad: "Medellín",
      comentario: "Las publicaciones estilo Instagram nos permiten mostrar nuestras instalaciones y clases. Conseguimos 50 nuevos miembros en 3 meses",
      calificacion: 5,
      persona: "Andrea López - Dueña"
    }
  ];

  const estadisticas = [
    { numero: "15,000+", label: "Empresas Registradas", icon: "Building2" },
    { numero: "85%", label: "Aumento Promedio en Visitas", icon: "TrendingUp" },
    { numero: "50,000+", label: "Clientes Activos Mensuales", icon: "Users" },
    { numero: "98%", label: "Satisfacción Empresarial", icon: "ThumbsUp" }
  ];

  const comparativa = [
    {
      metodo: "Publicidad Tradicional",
      costo: "$500,000 - $2,000,000 COP/mes",
      alcance: "Limitado geográficamente",
      medicion: "Difícil de medir resultados",
      color: "text-red-500"
    },
    {
      metodo: "Redes Sociales Pagadas",
      costo: "$300,000 - $1,500,000 COP/mes",
      alcance: "Requiere gestión constante",
      medicion: "Competencia alta por atención",
      color: "text-orange-500"
    },
    {
      metodo: "BIZZNET Empresas",
      costo: "REGISTRO GRATUITO",
      alcance: "Alcance a miles de usuarios activos",
      medicion: "Analytics detallados en tiempo real",
      color: "text-green-500"
    }
  ];

  return (
    <>
      <Helmet>
        <title>BIZZNET Empresas - Impulsa tu Negocio con Marketing Digital</title>
        <meta name="description" content="Únete a BIZZNET y conecta con miles de clientes. Perfil comercial, código QR, analytics, publicaciones y más. Registro gratuito para empresas colombianas." />
      </Helmet>

      <div className="min-h-screen bg-background">
        {/* Hero Section */}
        <section className="relative bg-gradient-to-br from-blue-900 via-blue-800 to-blue-700 py-16 px-6">
          <div className="max-w-7xl mx-auto">
            <div className="flex items-center gap-3 mb-6">
              <Link to="/" className="text-white/90 hover:text-white transition-colors drop-shadow-md">
                <Icon name="ArrowLeft" size={24} />
              </Link>
              <div className="flex items-center gap-3">
                <Icon name="Store" size={40} className="text-white drop-shadow-lg" />
                <h1 className="text-4xl md:text-5xl font-bold text-white drop-shadow-lg">BIZZNET Empresas</h1>
              </div>
            </div>
            <p className="text-xl md:text-2xl font-medium max-w-3xl text-white/95 drop-shadow-md mb-8">
              Transforma tu negocio en una potencia digital: más clientes, más ventas, más crecimiento
            </p>
            <div className="flex justify-center">
              <Link
                to="/business-registration"
                className="bg-white text-gray-900 px-8 py-4 rounded-xl font-semibold hover:bg-gray-100 transition-colors inline-flex items-center justify-center gap-2 shadow-lg"
              >
                <Icon name="Rocket" size={20} />
                Registrar Mi Empresa Gratis
              </Link>
            </div>
          </div>
        </section>

        {/* Estadísticas Clave */}
        <section className="py-12 px-6 bg-card border-b border-border">
          <div className="max-w-7xl mx-auto">
            <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-6">
              {estadisticas?.map((stat, index) => (
                <div key={index} className="text-center">
                  <div className="bg-primary/10 w-16 h-16 rounded-full flex items-center justify-center mx-auto mb-4">
                    <Icon name={stat?.icon} size={32} className="text-primary" />
                  </div>
                  <div className="text-4xl font-bold text-primary mb-2">{stat?.numero}</div>
                  <p className="text-sm text-muted-foreground">{stat?.label}</p>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* Beneficios Clave */}
        <section className="py-16 px-6">
          <div className="max-w-7xl mx-auto">
            <div className="text-center mb-12">
              <h2 className="text-3xl md:text-4xl font-bold text-foreground mb-4">
                ¿Qué Obtiene Tu Negocio al Registrarse?
              </h2>
              <p className="text-lg text-muted-foreground max-w-3xl mx-auto">
                Todo lo que necesitas para atraer clientes, aumentar ventas y crecer digitalmente en un solo lugar
              </p>
            </div>
            <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-6">
              {beneficiosClave?.map((beneficio, index) => (
                <div 
                  key={index}
                  className="bg-card border border-border rounded-xl p-6 hover:shadow-lg transition-shadow"
                >
                  <div className="bg-primary/10 w-14 h-14 rounded-xl flex items-center justify-center mb-4">
                    <Icon name={beneficio?.icon} size={28} className="text-primary" />
                  </div>
                  <h4 className="text-lg font-bold text-foreground mb-3">{beneficio?.title}</h4>
                  <p className="text-sm text-muted-foreground leading-relaxed">
                    {beneficio?.description}
                  </p>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* Analytics y QR Demo */}
        <section className="py-16 px-6 bg-card">
          <div className="max-w-7xl mx-auto">
            <div className="grid md:grid-cols-2 gap-12 items-center">
              <div>
                <div className="flex items-center gap-3 mb-6">
                  <Icon name="BarChart3" size={36} className="text-primary" />
                  <h2 className="text-3xl font-bold text-foreground">Panel de Control Empresarial</h2>
                </div>
                <p className="text-lg text-muted-foreground mb-6">
                  Accede a métricas detalladas sobre el comportamiento de tus clientes y el rendimiento de tus promociones
                </p>
                <ul className="space-y-4">
                  {[
                    "Número de escaneos QR diarios, semanales y mensuales",
                    "Identificación de clientes por nombre y contacto",
                    "Frecuencia de visitas y clientes recurrentes",
                    "Horarios pico de mayor actividad",
                    "Efectividad de cada descuento publicado",
                    "Crecimiento de seguidores y engagement"
                  ]?.map((item, idx) => (
                    <li key={idx} className="flex items-start gap-3">
                      <Icon name="CheckCircle2" size={20} className="text-green-500 flex-shrink-0 mt-1" />
                      <span className="text-muted-foreground">{item}</span>
                    </li>
                  ))}
                </ul>
              </div>
              <div className="bg-background border-2 border-border rounded-2xl p-8">
                <div className="bg-primary/5 rounded-xl p-6 mb-6">
                  <div className="flex items-center justify-between mb-4">
                    <h3 className="text-xl font-bold text-foreground">Métricas de Hoy</h3>
                    <Icon name="Calendar" size={24} className="text-primary" />
                  </div>
                  <div className="grid grid-cols-2 gap-4">
                    <div className="bg-card p-4 rounded-lg">
                      <div className="text-2xl font-bold text-primary">127</div>
                      <div className="text-sm text-muted-foreground">Visitas QR</div>
                    </div>
                    <div className="bg-card p-4 rounded-lg">
                      <div className="text-2xl font-bold text-primary">43</div>
                      <div className="text-sm text-muted-foreground">Nuevos Clientes</div>
                    </div>
                    <div className="bg-card p-4 rounded-lg">
                      <div className="text-2xl font-bold text-primary">89</div>
                      <div className="text-sm text-muted-foreground">Descuentos Usados</div>
                    </div>
                    <div className="bg-card p-4 rounded-lg">
                      <div className="text-2xl font-bold text-primary">+32%</div>
                      <div className="text-sm text-muted-foreground">vs Ayer</div>
                    </div>
                  </div>
                </div>
                <div className="flex items-center justify-center gap-4 p-6 bg-primary/5 rounded-xl">
                  <div className="bg-white p-4 rounded-lg">
                    <Icon name="QrCode" size={80} className="text-foreground" />
                  </div>
                  <div>
                    <p className="text-sm text-muted-foreground mb-2">Tu Código QR Único</p>
                    <p className="text-xs text-muted-foreground">Los clientes lo escanean para ver tus ofertas</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Publicaciones Estilo Instagram */}
        <section className="py-16 px-6">
          <div className="max-w-7xl mx-auto">
            <div className="text-center mb-12">
              <div className="flex items-center justify-center gap-3 mb-4">
                <Icon name="Image" size={36} className="text-primary" />
                <h2 className="text-3xl md:text-4xl font-bold text-foreground">
                  Marketing Visual Como Redes Sociales
                </h2>
              </div>
              <p className="text-lg text-muted-foreground max-w-3xl mx-auto">
                Comparte fotos de tus productos, servicios, local y promociones especiales. Atrae clientes con contenido visual atractivo
              </p>
            </div>
            <div className="grid sm:grid-cols-3 gap-6">
              {[
                { tipo: "Nuevos Productos", icon: "Package", descripcion: "Presenta tu inventario reciente" },
                { tipo: "Promociones Flash", icon: "Zap", descripcion: "Descuentos por tiempo limitado" },
                { tipo: "Detrás de Cámaras", icon: "Camera", descripcion: "Muestra el proceso de tu negocio" }
              ]?.map((tipo, idx) => (
                <div key={idx} className="bg-card border border-border rounded-xl p-6 text-center hover:shadow-lg transition-shadow">
                  <div className="bg-primary/10 w-20 h-20 rounded-full flex items-center justify-center mx-auto mb-4">
                    <Icon name={tipo?.icon} size={36} className="text-primary" />
                  </div>
                  <h3 className="text-xl font-bold text-foreground mb-3">{tipo?.tipo}</h3>
                  <p className="text-sm text-muted-foreground">{tipo?.descripcion}</p>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* Funciones Premium */}
        <section className="py-16 px-6 bg-card">
          <div className="max-w-7xl mx-auto">
            <div className="text-center mb-12">
              <h2 className="text-3xl md:text-4xl font-bold text-foreground mb-4">
                Funciones Avanzadas Incluidas
              </h2>
              <p className="text-lg text-muted-foreground">
                Herramientas profesionales para gestionar tu presencia digital de manera eficiente
              </p>
            </div>
            <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6">
              {funcionesPremium?.map((funcion, index) => (
                <div 
                  key={index}
                  className="bg-background border border-border rounded-xl p-6 hover:shadow-lg transition-shadow"
                >
                  <div className="bg-primary/10 w-14 h-14 rounded-xl flex items-center justify-center mb-4">
                    <Icon name={funcion?.icon} size={28} className="text-primary" />
                  </div>
                  <h4 className="text-lg font-bold text-foreground mb-3">{funcion?.title}</h4>
                  <p className="text-sm text-muted-foreground leading-relaxed">
                    {funcion?.description}
                  </p>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* Proceso de Registro */}
        <section className="py-16 px-6">
          <div className="max-w-7xl mx-auto">
            <div className="text-center mb-12">
              <h2 className="text-3xl md:text-4xl font-bold text-foreground mb-4">
                Cómo Empezar en 5 Pasos Simples
              </h2>
              <p className="text-lg text-muted-foreground">
                Del registro a tu primera venta en minutos. Proceso 100% digital y sin complicaciones
              </p>
            </div>
            <div className="space-y-6">
              {procesoPaso?.map((paso, index) => (
                <div 
                  key={index}
                  className="bg-card border border-border rounded-xl p-6 flex items-start gap-6 hover:shadow-lg transition-shadow"
                >
                  <div className="bg-primary text-primary-foreground w-16 h-16 rounded-full flex items-center justify-center flex-shrink-0 text-2xl font-bold">
                    {paso?.numero}
                  </div>
                  <div className="flex-1">
                    <div className="flex items-center gap-3 mb-3">
                      <Icon name={paso?.icon} size={28} className="text-primary" />
                      <h3 className="text-xl font-bold text-foreground">{paso?.titulo}</h3>
                    </div>
                    <p className="text-muted-foreground leading-relaxed">{paso?.descripcion}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* Comparativa de Costos */}
        <section className="py-16 px-6 bg-card">
          <div className="max-w-7xl mx-auto">
            <div className="text-center mb-12">
              <h2 className="text-3xl md:text-4xl font-bold text-foreground mb-4">
                BIZZNET vs Publicidad Tradicional
              </h2>
              <p className="text-lg text-muted-foreground">
                Compara el costo-beneficio y descubre por qué las empresas eligen BIZZNET
              </p>
            </div>
            <div className="space-y-4">
              {comparativa?.map((item, index) => (
                <div 
                  key={index}
                  className={`bg-background border-2 rounded-xl p-6 ${
                    item?.color === 'text-green-500' ? 'border-green-500 shadow-lg' : 'border-border'
                  }`}
                >
                  <div className="grid md:grid-cols-4 gap-4 items-center">
                    <div>
                      <h3 className={`text-xl font-bold ${item?.color}`}>{item?.metodo}</h3>
                    </div>
                    <div>
                      <p className="text-sm text-muted-foreground mb-1">Costo Mensual</p>
                      <p className="font-semibold text-foreground">{item?.costo}</p>
                    </div>
                    <div>
                      <p className="text-sm text-muted-foreground mb-1">Alcance</p>
                      <p className="font-semibold text-foreground">{item?.alcance}</p>
                    </div>
                    <div>
                      <p className="text-sm text-muted-foreground mb-1">Medición</p>
                      <p className="font-semibold text-foreground">{item?.medicion}</p>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* Testimonios */}
        <section className="py-16 px-6">
          <div className="max-w-7xl mx-auto">
            <div className="text-center mb-12">
              <h2 className="text-3xl md:text-4xl font-bold text-foreground mb-4">
                Lo Que Dicen Nuestras Empresas
              </h2>
              <p className="text-lg text-muted-foreground">
                Historias reales de negocios colombianos que crecieron con BIZZNET
              </p>
            </div>
            <div className="grid md:grid-cols-3 gap-6">
              {testimonios?.map((test, index) => (
                <div 
                  key={index}
                  className="bg-card border border-border rounded-xl p-6 hover:shadow-lg transition-shadow"
                >
                  <div className="flex gap-1 mb-4">
                    {[...Array(test?.calificacion)]?.map((_, i) => (
                      <Icon key={i} name="Star" size={20} className="text-yellow-500 fill-yellow-500" />
                    ))}
                  </div>
                  <p className="text-muted-foreground mb-4 italic leading-relaxed">
                    "{test?.comentario}"
                  </p>
                  <div className="border-t border-border pt-4">
                    <p className="font-bold text-foreground">{test?.negocio}</p>
                    <p className="text-sm text-muted-foreground">{test?.persona}</p>
                    <p className="text-xs text-muted-foreground flex items-center gap-1 mt-1">
                      <Icon name="MapPin" size={14} />
                      {test?.ciudad}
                    </p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* Beneficios Exclusivos */}
        <section className="py-16 px-6 bg-card">
          <div className="max-w-7xl mx-auto">
            <div className="text-center mb-12">
              <h2 className="text-3xl md:text-4xl font-bold text-foreground mb-4">
                Beneficios Exclusivos para Empresas Registradas
              </h2>
            </div>
            <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6">
              {[
                { icon: "CreditCard", titulo: "Sin Comisiones por Transacción", desc: "No cobramos porcentaje por cada venta realizada" },
                { icon: "Globe", titulo: "Directorio Priorizado", desc: "Tu negocio aparece en búsquedas destacadas según categoría" },
                { icon: "Users", titulo: "Acceso a Base de Usuarios", desc: "Conecta con miles de usuarios activos buscando ofertas" },
                { icon: "MessageSquare", titulo: "Chat Directo con Clientes", desc: "Responde consultas y atiende solicitudes en tiempo real" },
                { icon: "Share2", titulo: "Integración Redes Sociales", desc: "Comparte tus publicaciones en Instagram, Facebook y TikTok" },
                { icon: "Lock", titulo: "Perfil Seguro y Verificado", desc: "Certificación oficial que genera confianza en los clientes" }
              ]?.map((beneficio, idx) => (
                <div key={idx} className="bg-background border border-border rounded-xl p-6 hover:shadow-lg transition-shadow">
                  <div className="bg-primary/10 w-14 h-14 rounded-xl flex items-center justify-center mb-4">
                    <Icon name={beneficio?.icon} size={28} className="text-primary" />
                  </div>
                  <h4 className="text-lg font-bold text-foreground mb-3">{beneficio?.titulo}</h4>
                  <p className="text-sm text-muted-foreground leading-relaxed">{beneficio?.desc}</p>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* CTA Final */}
        <section className="py-16 px-6 bg-gradient-to-br from-blue-900 via-blue-800 to-blue-700">
          <div className="max-w-4xl mx-auto text-center">
            <h2 className="text-3xl md:text-4xl font-bold mb-6 text-white drop-shadow-lg">
              ¿Listo para Hacer Crecer Tu Negocio?
            </h2>
            <p className="text-lg mb-8 text-white/95 drop-shadow-md">
              Únete a las miles de empresas colombianas que ya están aumentando sus ventas con BIZZNET
            </p>
            <div className="flex flex-col sm:flex-row gap-4 justify-center mb-8">
              <Link
                to="/business-registration"
                className="bg-white text-gray-900 px-8 py-4 rounded-xl font-semibold hover:bg-gray-100 transition-colors inline-flex items-center justify-center gap-2 shadow-lg"
              >
                <Icon name="Rocket" size={20} />
                Registrar Mi Empresa AHORA
              </Link>
              <Link
                to="/faq"
                className="bg-white/10 text-white border-2 border-white/30 px-8 py-4 rounded-xl font-semibold hover:bg-white/20 transition-colors inline-flex items-center justify-center gap-2 backdrop-blur-sm"
              >
                <Icon name="HelpCircle" size={20} />
                Preguntas Frecuentes
              </Link>
            </div>
            <div className="flex items-center justify-center gap-8 text-white/90">
              <div className="flex items-center gap-2">
                <Icon name="CheckCircle2" size={20} />
                <span className="text-sm">Registro Gratuito</span>
              </div>
              <div className="flex items-center gap-2">
                <Icon name="CheckCircle2" size={20} />
                <span className="text-sm">Sin Comisiones</span>
              </div>
              <div className="flex items-center gap-2">
                <Icon name="CheckCircle2" size={20} />
                <span className="text-sm">Soporte 24/7</span>
              </div>
            </div>
          </div>
        </section>
      </div>
    </>
  );
};

export default BusinessBenefitsLanding;